import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LocationOnIcon } from '@features/regional-overview/assets/digital-traps/location_on.svg';
import type { NetworkTrapRow } from '../network-management.models';
import { useNetworkManagementStore } from '../network-management.zustand';

interface LocationCellProps {
  record: NetworkTrapRow;
}

export const LocationCell = ({ record }: LocationCellProps) => {
  const [t] = useTranslation();
  const { setIsModalOpen, setTrapName, setTrapId, setCoordinates } = useNetworkManagementStore();

  const handleLocationClick = () => {
    setIsModalOpen(true);
    setTrapName(record.name);
    setTrapId(record.id);
    setCoordinates(record.coordinates);
  };

  return (
    <Typography.Link onClick={handleLocationClick}>
      <Flex align='center' gap={4}>
        <LocationOnIcon fontSize={20} />
        {t('pages.regional_overview.digital_traps.location')}
      </Flex>
    </Typography.Link>
  );
};
